export default __webpack_public_path__ + "static/media/Parchment-transparent-1.e966b198.png";